useResubscribeIfNecessary